import React, { useState } from "react";
import "../../assets/scss/styles.scss";
import { SearchBarCommon } from "./search-bar-common";
import { useSessionStorage } from "../../modules/useSessionStorage"


// 🔴🔴🔴🔴🔴 another searchbar component
export const LandingSearchBar = () => {
    const [ allTags, setAllTags ] = useSessionStorage('all-tags', [])

    const getSelected = (isSelected, arr) => {
        return arr.filter(t => t.selected === isSelected)
    }

    const selected = () =>  getSelected(true, allTags)
    const suggested = () => getSelected(false, allTags)

    // for input values
    const [ searchTag, setSearchTag ] = useState('')
    const [ searchLocation, setSearchLocation ] = useSessionStorage('search-location', '');

    const handleSearch = () => {
        window.location.pathname = "/business-industry/find-a-contractor/results/";
    }

    const gtm_tracking = (e) => {

        e.preventDefault()

        // Get all Service Tag Elements
        let facSearchServiceTagElements = document.getElementsByClassName('fac-tag-select-content');

        // Loop through all Service Tag Elements and their text to 'facSearchServiceTags'
        let facSearchServiceTags = ''
        for (let i = 0; i < facSearchServiceTagElements.length; i++) {

            const element = facSearchServiceTagElements[i];

            // Add a comma if its not the first element
            if(i == 0) {
                facSearchServiceTags += element.textContent;
            } else {
                facSearchServiceTags += ", " + element.textContent;
            }

        }

        // Get
        let facSearchLocation = document.querySelector('.fac-input-location-field').value;

        // Add the data to the Datalayer object from Google Tag Manager
        window.dataLayer.push({
            "event": "fac-form-results",
            "fac-services": facSearchServiceTags,
            "fac-project-location": facSearchLocation
        });

    };

    const addGtmTracking = () => {
        let button = document.querySelector('.fac-update-search')
        button.addEventListener("click", gtm_tracking)
    }


    return (
    <div className="search-bar-landingpage">
        <SearchBarCommon
            allTags={allTags}
            setAllTags={setAllTags}
            selected={selected()}
            suggested={suggested()}
            searchTag={searchTag}
            setSearchTag={setSearchTag}
            searchLocation={searchLocation}
            setSearchLocation={setSearchLocation}
            handleSearch={handleSearch}
            searchBtn="Search"
        />
        {addGtmTracking}
    </div>

    )

}

